import React, { FC } from 'react';
import { useScanner } from '@/components/slides/GridScanner/useScanner.ts';
import { useNavigation } from '@/navigation/NavigationContex.ts';
import { QrScanner } from '@/components/slides/GridScanner/QrScanner.tsx';

interface GridInputProps {
  scannerEnabled: boolean;
}

export const GridInput: FC<GridInputProps> = ({ scannerEnabled }) => {
  const { currentSlide } = useNavigation();
  const { inputRef, gridValue, onInputChange, onScannerChange, reset } = useScanner();

  return (
    <>
      {scannerEnabled ? <QrScanner onScannerChange={onScannerChange} /> : <div className="viewport" />}

      <div className="input">
        <label htmlFor="barcode" className="prefix">
          {currentSlide!.prefix}
        </label>
        <input
          id="barcode"
          type="text"
          inputMode="numeric"
          ref={inputRef}
          value={gridValue}
          placeholder={currentSlide!.placeholder || ''}
          onChange={onInputChange}
        />
        <button className="clear" onClick={reset}>
          <i className="fas fa-times-circle" />
        </button>
      </div>
    </>
  );
};
